module.exports = __webpack_public_path__ + "c976442e32a435a0ea72b42d40dbe8ef.svg";